import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
	providedIn: 'root'
})
export class UserService {
	constructor(private http: HttpClient) { }

	billingInfoUpdate(billingData: any): Observable<Object> {
		return this.http.put(environment.apiUrl + '/users/billing/address', billingData);
	}
	loadClientSecret(): Observable<Object> {
		return this.http.post(environment.apiUrl + '/users/add/payments/method', {});
	}
	addPaymentMethod(paymentMethodId: string): Observable<any> {
		return this.http.post(environment.apiUrl + '/user_payments/payment-method/webhook', {
			payment_method_id: paymentMethodId
		});
	}
	getPaymentMethod(): Observable<any> {
		return this.http.get(environment.apiUrl + '/users/get/administrator/customers/information', {
		});
	}
	getSubscriptionDashboard(): Observable<any> {
		return this.http.get(environment.apiUrl + '/users/subscription/dashboard', {
		});
	}
	getsubscriptionplans(): Observable<any> {
		return this.http.get(environment.apiUrl + '/users/subscription/plans', {
		});
	}
	getClientSecret(): Observable<any> {
		return this.http.get(environment.apiUrl + '/users/client/secret', {
		});
	}
	getTransaction(): Observable<any> {
		return this.http.get(environment.apiUrl + '/users/billing/summary', {
		});
	}
	customersTransaction(UUID:any): Observable<any> {
	return this.http.get(environment.apiUrl + '/users/customers/billing/summary', {
		params: { UUID }
	});
	}
	// getUserSubscriptionDashboard(): Observable<any> {
	// 	return this.http.get(environment.apiUrl + '/users/getUser/Dashboard', {
	// 	});
	// }
	getUserShowsAvailabled(UUID: string): Observable<any> {
		return this.http.get(`${environment.apiUrl}/users/customer/shows/available`, {
			params: { UUID }
		});
	}
	getListener(userUUID: string): Observable<any> {
		return this.http.get(`${environment.apiUrl}/users/get/customer/listeners`, {
			params: { users_UUID: userUUID }
		});
	}
	getAllCustomerPaymentMethods(): Observable<any> {
		return this.http.get(environment.apiUrl + '/users/payments/GetAllMethods', {
		});
	}
	createSetupIntent(): Observable<any> {
		return this.http.post<any>(environment.apiUrl + '/users/add/payments/method', {});
	}
	addlistener(users_UUID: string, listeners_count: any): Observable<any> {
		const body = {
			users_UUID,
			listeners_count
		};
		return this.http.post<any>(environment.apiUrl + '/users/add/manual/listeners', body);
	}

	deletePaymentMethod(paymentMethodId: string, user_UUID: any): Observable<any> {
		return this.http.post(environment.apiUrl + '/user_payments/payment-method/detach', {
			paymentMethodId,
			user_UUID
		});
	}
	setCronJob(): Observable<any> {
		return this.http.get(environment.apiUrl + '/users/start/cron/cronjob');
	}

	billingCustomer(search: any): Observable<any> {
		return this.http.post(environment.apiUrl + '/users/administrator/customers', {
			'search': search
		});
	}
	billingInfoGet(): Observable<Object> {
		return this.http.get(environment.apiUrl + '/users/me', {});
	}

	setDefaultPaymentMethod(payment_method: string, stripe_customer_id: string): Observable<any> {
		return this.http.post(environment.apiUrl + '/user_payments/payment-method/set-default', {
			paymentMethodId: payment_method,
			stripeCustomerId: stripe_customer_id
		});
	}
	subscribeToPlan(plan: string, UUID: any): Observable<Object> {
		return this.http.post(environment.apiUrl + '/user_payments/subscribe', {
			subscriptionPlan: plan,
			userUUID: UUID,
		});
	}
	previewPlan(plan: string, UUID: any): Observable<Object> {
		return this.http.post(environment.apiUrl + '/user_payments/preview/subscribe', {
			subscription_plan: plan,
			user_uuid: UUID,
		});
	}
	cancelSubscription(UUID: any) {
		return this.http.post(environment.apiUrl + '/user_payments/cancel/Subscription', {
			cancelAtPeriodEnd: true,
			userUUID: UUID,
		});
	}
	// SubscriptionStatus(UUID: any): Observable<Object> { // this Api endpoint is not working
	// 	  return this.http.post(environment.apiUrl + '/users/check-subscription', {
	// 		user_UUID: UUID,
	// 	});
	// }
	checkSubscriptionPlanStatus(): Observable<Object> {
		  return this.http.get(environment.apiUrl + '/users/subscription', {
		});
	}

}
